import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

// "My work" cluster — annotator-facing tools that don't fit under
// /admin (which is permission-gated). Currently just the rejected-task
// inbox; future cards (e.g. "my submissions", "my drafts") slot in
// here too.
const my: AppRouteModule = {
  path: '/my',
  name: 'My',
  component: LAYOUT,
  redirect: '/my/tasks',
  meta: {
    icon: 'ant-design:inbox-outlined',
    title: '我的任务',
    orderNo: 5,
  },
  children: [
    {
      // M4 我的任务 — assignments dispatched to the logged-in user
      // (GET /data/assignment/my, any logged-in user).
      path: 'tasks',
      name: 'MyTasks',
      component: () => import('/@/views/my/tasks/index.vue'),
      meta: {
        title: t('routes.assignment.myTasks'),
        icon: 'ant-design:profile-outlined',
      },
    },
    {
      path: 'rejected',
      name: 'MyRejected',
      component: () => import('/@/views/my/rejected/index.vue'),
      meta: {
        title: '我的退回任务',
        icon: 'ant-design:rollback-outlined',
        // URL 直达拦截(老板 2026-09-05 审计修复):退回箱是标注员工作入口,
        // 纯审核员(data:audit 无 data:annotate)直访被守卫拦下;质检员持有
        // data:annotate 会放行,由页面级 onMounted 早退再跳"我的任务"兜底。
        permission: 'data:annotate',
      },
    },
    {
      // 我领的任务(老板 2026-09-30):认领后名下的活独立成页,
      // 从 my/tasks 拆出;深链 ?status=IN_PROGRESS|SUBMITTED|RETURNED 直达 tab
      path: 'claimed',
      name: 'MyClaimed',
      component: () => import('/@/views/my/claimed/index.vue'),
      meta: {
        title: '我领的任务',
        icon: 'ant-design:carry-out-outlined',
        permission: 'data:annotate',
      },
    },
    {
      // 我领取的审核任务(老板 2026-09-30):质检/审核独立页面,
      // 侧栏"质检任务/审核任务"分组的第二个子项
      path: 'claimed-review',
      name: 'MyClaimedReview',
      component: () => import('/@/views/my/claimedReview/index.vue'),
      meta: {
        title: '我领取的任务',
        icon: 'ant-design:lock-outlined',
        permission: ['data:qc', 'data:audit'],
      },
    },
    {
      path: 'review-history',
      name: 'MyReviewHistory',
      component: () => import('/@/views/my/reviewHistory/index.vue'),
      meta: {
        title: '我的处理记录',
        icon: 'ant-design:history-outlined',
        permission: ['data:qc', 'data:audit'],
      },
    },
    {
      // 我的申诉(老板 2026-09-30):申诉记录独立成页,
      // 发起入口在「我领的任务」的返工任务行内
      path: 'appeals',
      name: 'MyAppeals',
      component: () => import('/@/views/my/appeals/index.vue'),
      meta: {
        title: '我的申诉',
        icon: 'ant-design:audit-outlined',
        permission: 'data:annotate',
      },
    },
    // 众包/培训残留页下线(老板 2026-09-05 审计:redirect 目标已从路由表
    // 移除,链接项整体删除——空对象会令路由构建时 component.startsWith
    // 读取 undefined 而崩溃(登录报 startsWith 错误即此)。Phase 2 重启时
    // 连同 mainOut.ts 一起恢复:
    // { path: 'training-link', name: 'MyTrainingLink', redirect: '/training',
    //   meta: { title: '培训中心', icon: 'ant-design:read-outlined' } },
    // { path: 'marketplace-link', name: 'MyMarketplaceLink', redirect: '/marketplace',
    //   meta: { title: '众包市场', icon: 'ant-design:shop-outlined' } },
  ],
};

export default my;
